import { OFFER_VERSION } from './criar-musica-catalog.mjs';

export const VOICE_GENDERS = Object.freeze(['Voz feminina', 'Voz masculina']);

export const onlyDigits = (value) => String(value || '').replace(/\D/g, '');

export const validEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());

export function pickVoiceGender(random = Math.random) {
  return VOICE_GENDERS[random() < 0.5 ? 0 : 1];
}

export function validateForm(form) {
  if (!form || !form.recipient || !String(form.recipientName || '').trim()) return 'recipient_incomplete';
  if (!form.occasion || !form.mood || !form.genre || !form.subgenre || !form.voiceGender || !String(form.qualities || '').trim()) return 'briefing_incomplete';
  const phoneDigits = onlyDigits(form.whatsapp);
  const hasName = Boolean(String(form.customerName || '').trim());
  const hasEmail = validEmail(form.email);
  const hasWhatsapp = phoneDigits.length >= 10;
  if (!hasName || (!hasEmail && !hasWhatsapp)) return 'contact_incomplete';
  if (phoneDigits && phoneDigits.length < 10) return 'contact_incomplete';
  return null;
}

export function buildCreateOrderPayload(wizard, options = {}) {
  const phoneDigits = onlyDigits(wizard.phone);
  const style = String(wizard.style || '').trim();
  return {
    offer_version: OFFER_VERSION,
    form: {
      recipient: String(wizard.relationship || '').trim(),
      recipientName: String(wizard.recipientName || '').trim(),
      occasion: wizard.occasion,
      mood: wizard.mood,
      genre: style,
      subgenre: style,
      voiceGender: String(wizard.voiceGender || '').trim() || options.voiceGender || pickVoiceGender(options.random),
      qualities: String(wizard.qualities || '').trim(),
      memories: String(wizard.memories || '').trim(),
      heartMessage: String(wizard.heartMessage || '').trim(),
      customerName: String(wizard.customerName || '').trim(),
      whatsapp: phoneDigits.length >= 10 ? String(wizard.phone || '').trim() : '',
      email: String(wizard.email || '').trim(),
    },
  };
}
